/**
 * Template CSV para importação de colaboradores corporativos.
 * Inclui dados pessoais + organizacionais (setor, cargo, responsável).
 */

export const TEMPLATE_HEADERS_PT = [
    'Nome',
    'Email',
    'Status',
    'CPF',
    'Identidade',
    'Telefone',
    'CEP',
    'Endereço',
    'Número',
    'Complemento',
    'Bairro',
    'Cidade',
    'Estado',
    'País',
    'Setor',
    'Cargo',
    'Responsável pelo setor',
];

/** Chaves alinhadas ao formulário de colaborador */
export const TEMPLATE_HEADERS_KEY = [
    'name',
    'email',
    'status',
    'socialNumber',
    'idNumber',
    'phone',
    'postcode',
    'address',
    'addressNumber',
    'addressComplement',
    'neighborhood',
    'city',
    'county',
    'country',
    'sector',
    'role',
    'isResponsible',
];

export const TEMPLATE_EXAMPLE_ROWS = [
    [
        'Ana Costa',
        'ana.costa@empresa.com',
        'active',
        '123.456.789-00',
        'MG1234567',
        '(11) 99999-9999',
        '01310-100',
        'Rua Exemplo',
        '100',
        'Apto 12',
        'Bela Vista',
        'São Paulo',
        'SP',
        'br',
        'RH',
        'Analista',
        'nao',
    ],
    [
        'Bruno Lima',
        'bruno.lima@empresa.com',
        'active',
        '987.654.321-00',
        'SP7654321',
        '(21) 98888-7777',
        '20040-020',
        'Av. Central',
        '50',
        'Sala 3',
        'Centro',
        'Rio de Janeiro',
        'RJ',
        'br',
        'Comercial',
        'Gestor',
        'sim',
    ],
];

function escapeCsvCell(value) {
    const text = String(value ?? '');
    if (/[",\n\r]/.test(text)) {
        return `"${text.replace(/"/g, '""')}"`;
    }
    return text;
}

export function buildCollaboratorImportCsv() {
    const lines = [
        TEMPLATE_HEADERS_PT.join(','),
        TEMPLATE_HEADERS_KEY.join(','),
        ...TEMPLATE_EXAMPLE_ROWS.map((row) =>
            row.map(escapeCsvCell).join(','),
        ),
    ];
    return `\uFEFF${lines.join('\n')}`;
}
